<template lang="pug">
PublicEditalLayout
  .cadastro-formulario(v-loading="loading")
    CadastroPageHeader(
      :titulo="tituloPagina"
      :subtitulo="subtituloPagina"
    )

    validation-observer(ref="observer" tag="form")
      form.cadastro-formulario__card(@submit.prevent="confirmarTermos")
        section.cadastro-formulario__section
          CadastroSectionLabel(label="Dados pessoais" variant="md")

          .cadastro-formulario__row.cadastro-formulario__row--cpf-nome
            validation-provider(
              ref="cpf"
              :rules="{ required: true, cpf: true }"
              v-slot="{ errors }"
              name="cpf"
            )
              CadastroFormField(label="CPF" required :error="errors[0]")
                CadastroFormInput(
                  v-model="credenciado.pessoa.pessoaFisica.cpf"
                  v-mask="['###.###.###-##']"
                  placeholder="000.000.000-00"
                )

            validation-provider(
              ref="nome"
              :rules="{ required: true }"
              v-slot="{ errors }"
              name="nome"
            )
              CadastroFormField(label="Nome" required :error="errors[0]")
                CadastroFormInput(
                  v-model="credenciado.pessoa.pessoaFisica.nome"
                  placeholder="Digite seu nome completo"
                )

          .cadastro-formulario__row.cadastro-formulario__row--telefones-emails
            validation-provider(ref="telefones" name="telefones")
              CadastroFormField(
                label="Telefone(s)"
                required
                :error="validaCampoTelefone ? 'O campo é obrigatório' : ''"
              )
                CadastroTelefonesInput(
                  v-model="fone"
                  :telefones="numeroTelefone"
                  :disabled="numeroTelefone.length >= 3"
                  @add="addTelefone"
                  @remove="removeTelefone"
                )

            validation-provider(
              ref="email"
              :rules="{ required: true, email: true }"
              v-slot="{ errors }"
              name="email"
            )
              CadastroFormField(label="E-mail" required :error="errors[0]")
                CadastroFormInput(
                  v-model="credenciado.pessoa.email"
                  type="email"
                  placeholder="Digite seu e-mail"
                )

            validation-provider(
              ref="e-mail"
              rules="required|email|confirmed:email"
              v-slot="{ errors }"
              name="e-mail"
            )
              CadastroFormField(label="Confirmar e-mail" required :error="errors[0]")
                CadastroFormInput(
                  v-model="confirmarEmail"
                  type="email"
                  placeholder="Confirme seu e-mail"
                )

        section.cadastro-formulario__section
          CadastroSectionLabel(label="Formação" variant="md")

          .cadastro-formulario__row.cadastro-formulario__row--2cols
            validation-provider(
              v-if="tipoCadastro === 'VISTORIADOR'"
              ref="formacao"
              :rules="{ required: true }"
              v-slot="{ errors }"
              name="formacao"
            )
              CadastroFormField(label="Formação" required :error="errors[0]")
                CadastroFormSelect(
                  v-model="credenciado.formacao"
                  :options="tiposFormacoes"
                  label-key="descricao"
                  value-key="codigo"
                  placeholder="Selecione a formação"
                )

            validation-provider(
              v-else
              ref="formacao"
              :rules="{ required: true }"
              v-slot="{ errors }"
              name="formacao"
            )
              CadastroFormField(label="Formação" required :error="errors[0]")
                CadastroFormInput(
                  v-model="credenciado.formacao"
                  placeholder="Digite a formação"
                )

            validation-provider(
              ref="codigoCrea"
              :rules="{ required: true }"
              v-slot="{ errors }"
              name="codigoCrea"
            )
              CadastroFormField(label="Registro no conselho" required :error="errors[0]")
                CadastroFormInput(
                  v-model="credenciado.codigoCrea"
                  placeholder="Digite o registro"
                )

          .cadastro-formulario__row.cadastro-formulario__row--2cols(v-if="tipoCadastro === 'GEOMENSOR'")
            validation-provider(
              ref="codigoIncra"
              :rules="{ required: true }"
              v-slot="{ errors }"
              name="codigoIncra"
            )
              CadastroFormField(label="Código de credenciamento no INCRA" required :error="errors[0]")
                CadastroFormInput(
                  v-model="credenciado.codigoIncra"
                  maxlength="4"
                  placeholder="Digite o código INCRA"
                )

        section.cadastro-formulario__section
          CadastroSectionLabel(label="Endereço" variant="md")

          .cadastro-formulario__grid
            validation-provider(
              ref="cep"
              :rules="{ required: true, cep: true }"
              v-slot="{ errors }"
              name="cep"
            )
              CadastroFormField(label="CEP" required :error="errors[0]")
                CadastroFormInput(
                  v-model="credenciado.pessoa.endereco.cep"
                  v-mask="'#####-###'"
                  placeholder="Digite seu CEP"
                )

            validation-provider(
              ref="uf"
              :rules="{ required: true }"
              v-slot="{ errors }"
              name="uf"
            )
              CadastroFormField(label="UF" required :error="errors[0]")
                CadastroFormSelect(
                  v-model="credenciado.pessoa.endereco.uf"
                  :options="estados"
                  primitive-options
                  placeholder="Selecione a UF"
                  @input="changeUf"
                )

            validation-provider(
              ref="municipio"
              :rules="{ required: true }"
              v-slot="{ errors }"
              name="municipio"
            )
              CadastroFormField(label="Município" required :error="errors[0]")
                CadastroFormSearchSelect(
                  :value="credenciado.pessoa.endereco.municipio.nome"
                  :options="listMunicipios"
                  label-key="nome"
                  value-key="nome"
                  placeholder="Digite ou selecione o município"
                  :disabled="!credenciado.pessoa.endereco.uf"
                  @input="handleChangeMunicipio"
                  @focus="handleMunicipios(credenciado.pessoa.endereco.uf)"
                )

            validation-provider(
              ref="Bairro"
              :rules="{ required: true }"
              v-slot="{ errors }"
              name="Bairro"
            )
              CadastroFormField(label="Bairro" required :error="errors[0]")
                CadastroFormInput(
                  v-model="credenciado.pessoa.endereco.bairro"
                  placeholder="Nome do bairro"
                )

            .cadastro-formulario__grid-span-2
              validation-provider(
                ref="logradouro"
                :rules="{ required: true }"
                v-slot="{ errors }"
                name="logradouro"
              )
                CadastroFormField(label="Logradouro" required :error="errors[0]")
                  CadastroFormInput(
                    v-model="credenciado.pessoa.endereco.logradouro"
                    maxlength="100"
                    placeholder="Nome da Rua, Avenida, etc"
                  )

            .cadastro-formulario__numero-sn
              validation-provider(
                ref="numero"
                :rules="{ required: !credenciado.pessoa.endereco.numero && !credenciado.pessoa.endereco.semNumero }"
                v-slot="{ errors }"
                name="numero"
              )
                CadastroFormField(label="Numero" required :error="errors[0]")
                  .cadastro-formulario__numero-sn-row
                    CadastroFormInput(
                      v-model="credenciado.pessoa.endereco.numero"
                      type="number"
                      :disabled="credenciado.pessoa.endereco.semNumero"
                      placeholder="Número da residencia"
                    )
                    CadastroCheckboxSn(
                      :value="credenciado.pessoa.endereco.semNumero"
                      @input="onSemNumeroToggle"
                    )

            .cadastro-formulario__grid-span-2
              validation-provider(
                ref="complemento"
                name="complemento"
              )
                CadastroFormField(label="Complemento")
                  CadastroFormInput(
                    v-model="credenciado.pessoa.endereco.complemento"
                    placeholder="Ex.: APT 102"
                  )

        section.cadastro-formulario__section
          CadastroSectionLabel(label="Documentação" variant="md")

          validation-provider(
            :rules="requireDocumentosObrigatorios()"
            v-slot="{ errors }"
            name="Credenciado/Documentos"
          )
            .cadastro-formulario__documentos
              el-table.cadastro-formulario__documentos-sync(
                :data="credenciado.documentos"
                v-model="validationValuesDocumentos"
                style="display: none"
              )
              CadastroDocumentacao(
                :documentos="credenciado.documentos"
                :tipos-documentos="tiposDocumentos.tipos"
                :tipos-documentos-obrigatorios="tiposDocumentos.obrigatorios"
                :url="url"
                :valid-extensions="extensoesUploadDocumentacao"
                :max-size="20"
                :formatos-texto="formatosDocumento"
                @addDoc="adicionaDoc"
                @removeDoc="executarRemocaoDoc"
                @tipoDocumentoOnChange="changeTipoDocumentoAtivo"
                @updateTipoDocumento="onUpdateTipoDocumento"
              )
              span.cadastro-formulario__error(v-if="errors[0]") {{ errors[0] }}

        CadastroPageActions(
          :mostrar-voltar="true"
          :mostrar-cadastrar="true"
          @cancelar="cancelar"
          @voltar="voltar"
          @cadastrar="confirmarTermos"
        )

    modal-termos(
      :tipo-cadastro="tipoCadastro"
      :modal-open="visualizarTermos"
      @close-modal="visualizarTermos = false"
      @confirmar="cadastrar"
    )

    CadastroConfirmDialog(
      :aberto="modalCancelarAberto"
      :titulo="$messages.TITULO_WARNING"
      :mensagem="$messages.CANCELAR_CADASTRO"
      @cancelar="fecharModalCancelar"
      @confirmar="confirmarCancelamento"
    )
</template>

<script>
import PublicEditalLayout from '@/components/editais/PublicEditalLayout'
import CadastroPageHeader from '@/components/cadastro/CadastroPageHeader'
import CadastroSectionLabel from '@/components/cadastro/CadastroSectionLabel'
import CadastroFormField from '@/components/cadastro/CadastroFormField'
import CadastroFormInput from '@/components/cadastro/CadastroFormInput'
import CadastroFormSelect from '@/components/cadastro/CadastroFormSelect'
import CadastroFormSearchSelect from '@/components/cadastro/CadastroFormSearchSelect'
import CadastroTelefonesInput from '@/components/cadastro/CadastroTelefonesInput'
import CadastroCheckboxSn from '@/components/cadastro/CadastroCheckboxSn'
import CadastroDocumentacao from '@/components/cadastro/CadastroDocumentacao'
import CadastroPageActions from '@/components/cadastro/CadastroPageActions'
import CadastroConfirmDialog from '@/components/cadastro/CadastroConfirmDialog'
import ModalTermos from '@/components/modalTermoCompromisso'
import cadastroCredenciadoMixin from '@/screens/credenciados/cadastroCredenciadoMixin'
import {
  CADASTRO_EXTENSOES_UPLOAD,
  CADASTRO_FORMATOS_DOCUMENTO,
  CADASTRO_SUBTITULOS,
  CADASTRO_TITULOS
} from '@/constants/cadastroPublico'

export default {
  name: 'CadastroCredenciadoFormulario',
  components: {
    PublicEditalLayout,
    CadastroPageHeader,
    CadastroSectionLabel,
    CadastroFormField,
    CadastroFormInput,
    CadastroFormSelect,
    CadastroFormSearchSelect,
    CadastroTelefonesInput,
    CadastroCheckboxSn,
    CadastroDocumentacao,
    CadastroPageActions,
    CadastroConfirmDialog,
    ModalTermos
  },
  mixins: [cadastroCredenciadoMixin],
  computed: {
    tituloPagina () {
      const tipo = CADASTRO_TITULOS[this.tipoCadastro] || 'credenciado'
      return `Cadastro de credenciado ${tipo}`
    },
    subtituloPagina () {
      return CADASTRO_SUBTITULOS.formulario
    },
    formatosDocumento () {
      return CADASTRO_FORMATOS_DOCUMENTO
    },
    // Upload ocorre antes da escolha do tipo: sempre permite formatos de documento e foto.
    extensoesUploadDocumentacao () {
      return CADASTRO_EXTENSOES_UPLOAD
    },
    validationValuesDocumentos () {
      return {
        documentos: this.credenciado.documentos,
        documentosObrigatorios: this.tiposDocumentos.obrigatorios
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    if (to.name === 'credenciados/cadastro') {
      this.salvarRascunhoFormulario()
    }
    next()
  },
  async mounted () {
    await this.initCadastro()
    this.restaurarRascunhoFormulario()

    if (this.credenciado.pessoa.endereco.uf) {
      await this.handleMunicipios(this.credenciado.pessoa.endereco.uf)
    }
  },
  methods: {
    voltar () {
      this.$router.push({
        name: 'credenciados/cadastro',
        params: { idEdital: this.idEdital }
      })
    },

    onSemNumeroToggle (checked) {
      this.credenciado.pessoa.endereco.semNumero = checked
      this.onSemNumeroCheck(checked)
    },

    onUpdateTipoDocumento ({ documento, tipo }) {
      this.atualizarTipoDocumento(documento, tipo)
    },

    requireDocumentosObrigatorios () {
      return this.tiposDocumentos.obrigatorios.length ? 'documentosObrigatorios' : ''
    }
  }
}
</script>

<style lang="scss" scoped>
.cadastro-formulario__card {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 0 0 1px rgba(20, 20, 20, 0.1);
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
}

.cadastro-formulario__section {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.cadastro-formulario__row {
  display: grid;
  gap: 16px;

  &--cpf-nome {
    grid-template-columns: minmax(280px, 402px) minmax(0, 1fr);
  }

  &--telefones-emails {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  &--2cols {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

.cadastro-formulario__grid {
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.cadastro-formulario__grid-span-2 {
  grid-column: span 2;
}

.cadastro-formulario__numero-sn-row {
  align-items: center;
  display: flex;
  gap: 12px;
  width: 100%;

  > :first-child {
    flex: 1;
    min-width: 0;
  }
}

.cadastro-formulario__documentos {
  width: 100%;
}

.cadastro-formulario__error {
  color: #ef4444;
  display: block;
  font-family: 'Inter', 'Ubuntu', sans-serif;
  font-size: 12px;
  margin-top: 8px;
  white-space: pre-line;
}

@media (max-width: 1024px) {
  .cadastro-formulario__row--cpf-nome,
  .cadastro-formulario__row--telefones-emails,
  .cadastro-formulario__row--2cols,
  .cadastro-formulario__grid {
    grid-template-columns: 1fr;
  }

  .cadastro-formulario__grid-span-2 {
    grid-column: span 1;
  }
}
</style>
